module.exports = {"button.check.availability":"Mostrar disponibilidad"}


//////////////////
// WEBPACK FOOTER
// ./src/static/locales/es.json
// module id = 333
// module chunks = 0